<template>
  <div class="file-details">
    <el-main>
      <div class="file-content">
        <h3 class="title">{{ fileRes.name }}</h3>
        <div class="other_info">
          <div class="time" v-if="fileRes.type == 2">
            發佈日期：{{ $dayjs(fileRes.publish_time).format("YYYY-MM-DD") }}
          </div>
          <div class="time" v-else>
            成文日期：{{ $dayjs(fileRes.writed_time).format("YYYY-MM-DD") }}
          </div>
        </div>
        <div v-html="fileRes.content" class="con"></div>
        <div class="show_more" v-if="isShowMore">
          <div class="artlineContent"></div>
          <div class="tongjiNumber little_hand" @click="isShowFeeList = true">
            <span class="box_titlecontent cost-uibtn">訂閱後繼續閱讀</span>
            <div class="triangle"></div>
          </div>
          <div class="loginContent" v-if="!validToken">
            <span
              class="color40 loginColor openLoginWindowMain little_hand"
              @click="$store.state.isDialogVisible = true"
              >登錄</span
            >
            &nbsp;後獲取已訂閱的閱讀權限
          </div>
          <div class="subBtnContent">
            <div class="subLeftContent">
              深圳台協收費文章<br />請購買後查看全文
            </div>
            <span
              class="subRightContent cost-uibtn little_hand"
              @click="isShowFeeList = true"
              >訂閱</span
            >
          </div>
          <!-- 　　<span class="show_more_btn" @click="isShowFeeList=true">￥{{fileRes.current_price}} 解鎖文章</span> -->
        </div>
        <div class="share_container">
          <span class="tag">分享：</span>
          <div class="wx little_hand">
            <el-popover
              placement="top"
              width="100"
              trigger="hover"
              popper-class="wx_popper"
            >
              <el-image
                style="width: 100px; height: 100px"
                :src="qrCodeImg"
                fit="cover"
              ></el-image>
              <img
                slot="reference"
                src="https://www.sztmas.cn/assets/images/weixin1.png"
                alt=""
              />
            </el-popover>
          </div>
          <div class="wb little_hand" @click="shareToWb">
            <img src="https://www.sztmas.cn/assets/images/weibo.png" alt="" />
          </div>
        </div>
      </div>
      <div class="relate_article" v-if="newsList.length > 0">
        <h3>相關解讀:</h3>
        <ul>
          <li
            v-for="(item, index) in newsList"
            :key="index"
            @click="fnToArticleExplain(item.explain_id)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
      <!-- <a :href="mweb_url">{{mweb_url}}</a>-->
    </el-main>
    <el-dialog
      :visible.sync="isShowFeeList"
      title="選擇付費方式"
      width="450px"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <i class="el-icon-close" @click="isShowFeeList = false"></i>
      <div class="fee_list">
        <div
          class="fee_list_item"
          v-for="item in feeList"
          :key="item.name"
          @click="fnToPay(item.equitypackage_id, item.price)"
        >
          <span class="name">{{ item.name }}</span>
          <span class="price">￥ {{ item.price }}</span>
          <span class="desc">{{ item.description }}</span>
          <!-- <span :class="$style.duration">{{item.duration}}</span> -->
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="isShowQcode"
      title="打開微信掃一掃付款"
      width="450px"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <i class="el-icon-close" @click="isShowQcode = false"></i>
      <img :src="payCode" width="200px" height="200px" />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
var timer;
export default {
  data() {
    return {
      isShowMore: false,
      isShowFeeList: false,
      isShowQcode: false,
      fileRes: {},
      isPaying: false, //是否正在支付
      payStartTime: "",
      feeList: [
        {
          name: "單篇付費",
          price: 0,
          description: "單篇",
          equitypackage_id: 0,
        },
      ],
      code_url: "",
      newsList: [],
    };
  },
  computed: {
    ...mapState(["user_id", "validToken"]),
    qrCodeImg() {
      return (
        "https://api2.ts960.com/jehc-web-app/api/v2/QRcode/createQRcode?url=https://api2.ts960.com/wechatxh/html/association-file-details.html?cunpan_id=" +
        this.$route.params.id
      );
    },
    payCode() {
      return `https://api2.ts960.com/jehc-web-app/api/v2/QRcode/createQRcode?url=${this.code_url}`;
    },
  },
  methods: {
    async getFileDetails() {
      const { data: res } = await this.$http.get(
        `/api/v2/cunpan/${this.$route.params.id}`
      );
      // console.log(res);
      // if (res.code !== "200") return this.$message.error(res.msg);
      this.fileRes = res.data;
      let newdate = new Date();
      let diff = (newdate - this.payStartTime) / 1000 / 60;
      // console.log(diff)
      if (res.code == 51000) {
        if (diff > 5 && this.isPaying) {
          this.$message.error("支付失敗");
          clearInterval(timer);
          this.isShowQcode = false;
          this.isShowFeeList = false;
        }
        this.isShowMore = true;
        this.fileRes.content = res.data.content.substring(0, 1000);
      } else {
        if (this.isPaying) {
          this.$message.success("支付成功");
          clearInterval(timer);
        }
        this.isShowMore = false;
        this.isShowQcode = false;
        this.isShowFeeList = false;
        this.fileRes.content = res.data.content;
      }
      this.feeList[0].price = res.data.current_price;
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    //解读
    async getFileList() {
      const { data: res } = await this.$http.get("/api/v2/cunpanExplain/list", {
        params: {
          start: this.start,
          limit: this.limit,
          searchJson: {
            cunpan_id: this.$route.params.id,
          },
        },
      });
      if (res.code !== "200") return this.$message.error(res.msg);
      this.newsList = res.data;
      setTimeout(() => {
        this.$zhTran();
      }, 300);
    },
    // 获取文章包月费用
    async getArticleEquitypackage() {
      const { data: res } = await this.$http.get(
        `api/v2/article/articleEquitypackage`
      );
      // console.log(res);
      // if (res.code !== "200") return this.$message.error(res.msg);
      res.data.map((item) => {
        this.feeList.push({
          name: item.name,
          price: item.price,
          duration: item.duration,
          description: item.description,
          equitypackage_id: item.equitypackage_id,
        });
      });
    },
    async fnToPay(equitypackage_id, money) {
      // console.log(localStorage.getItem('Ip'))
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        let cunpanUrl = "";
        if (equitypackage_id == 0) {
          cunpanUrl = `/api/v2/order/resourcesPayByH5/${
            this.$route.params.id
          }/14/${
            this.user_id
          }/${money}/${"Tobfusion"}?ipAddress=${localStorage.getItem("Ip")}`;
        } else {
          cunpanUrl = `/api/v2/order/resourcesPayByH5/${equitypackage_id}/13/${
            this.user_id
          }/${money}/${"Tobfusion"}?ipAddress=${localStorage.getItem("Ip")}`;
        }
        const { data: res } = await this.$http.post(cunpanUrl);
        // console.log(res.data.code_url);
        this.code_url = res.data.code_url;
        this.isShowQcode = true;
        this.isShowFeeList = false;
        // alert(this.mweb_url)
        // window.open(this.mweb_url, "newwindow");
        this.isPaying = true;
        this.payStartTime = new Date();
        timer = setInterval(() => {
          this.getFileDetails();
        }, 5000);
      }
    },
    shareToWb() {
      let title = this.fileRes.name;
      let url =
        "https://api2.ts960.com/wechatxh/html/association-file-details.html?cunpan_id=" +
        this.$route.params.id;
      var sharesinastring =
        "http://v.t.sina.com.cn/share/share.php?title=" +
        title +
        "&url=" +
        url +
        "&content=utf-8&sourceUrl=" +
        url;
      window.open(
        sharesinastring,
        "newwindow",
        "height=400,width=400,top=100,left=100"
      );
    },
    fnToArticleExplain(explain_id) {
      this.$router.push({
        path: `/article-explain/${explain_id}`,
      });
    },
  },
  created() {
    this.getFileDetails();
    this.getArticleEquitypackage();
    this.getFileList();
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.file-details {
  background: #f2f2f2;
  padding: 50px 0;
}
.el-main {
  width: 1200px;
  display: flex;
  .title {
    font-family: MicrosoftYaHei-Bold;
    font-size: 36px;
    color: #222222;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .other_info {
    position: relative;
    margin-bottom: 40px;
    .time {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #888888;
      letter-spacing: 0;
      text-align: justify;
      font-weight: 400;
    }
  }
  .show_more {
    width: 100%;
    text-align: center;
    padding: 40px 0;
    // margin-top: -74px;
    position: relative;
    .artlineContent {
      // background: url(../assets/images/lineContent.png) repeat-x;
      height: 44px;
      z-index: 2;
      position: absolute;
      top: 0;
      width: 100%;
    }
    .tongjiNumber {
      font-size: 18px;
      color: #282828;
      text-align: center;
      .triangle {
        border-bottom: 4px solid transparent;
        border-top: 4px solid #f12e2b;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        width: 0;
        height: 0;
        overflow: hidden;
        margin: 5px auto 28px;
      }
    }
    .loginContent {
      font-size: 18px;
      margin-bottom: 30px;
      .loginColor {
        color: #2686d5;
        border-bottom: 1px solid #2686d5;
        padding-bottom: 2px;
        font-size: 18px;
      }
    }
    .subBtnContent {
      margin-bottom: 25px;
      font-size: 18px;
      color: #b0977f;
      text-align: right;
      width: 350px;
      margin: 0 auto 25px;
      height: 44px;
      .subLeftContent {
        border-right: 1px solid #f8ad18;
        padding-right: 18px;
        margin-right: 18px;
        float: left;
      }
      .subRightContent {
        float: left;
        width: 150px;
        border-radius: 40px;
        line-height: 44px;
        background: #f8ad18;
        font-size: 20px;
        color: #fff;
        position: relative;
        text-align: center;
      }
    }
  }
  .show_more .show_more_btn {
    text-decoration: none;
    color: #333;
    padding: 10px 20px;
    border: 1px solid #67a2ea;
    border-radius: 40px;
    font-size: 18px;
  }
  .share_container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 15px;
    .tag {
      font-size: 16px;
      font-weight: 300;
      color: #424242;
      line-height: 42px;
      margin-right: 15px;
      padding: 6px 0;
    }
    .wx {
      span {
        display: flex;
      }
    }
    div {
      width: 45px;
      height: 45px;
      border-radius: 45px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      padding: 10px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-right: 10px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }

  /deep/.el-dialog {
    border-radius: 22px;
    margin-top: 30vh !important;
    .el-dialog__title {
      line-height: 60px;
      font-size: 20px;
      color: #303133;
      font-weight: bold;
    }
    i {
      position: absolute;
      right: 25px;
      top: 25px;
      font-size: 28px;
      font-weight: bold;
      cursor: pointer;
    }
    img {
      margin: auto;
      display: block;
    }
    .fee_list {
      display: flex;
      align-content: center;
      justify-content: space-around;
      .fee_list_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 20px;
        border-right: 1px dashed #ccc;
        cursor: pointer;
        .price {
          font-size: 18px;
          color: #f12e2b;
        }
        .name {
          font-size: 18px;
        }
        .desc {
          font-size: 16px;
          color: #ccc;
        }
        .duration {
          font-size: 16px;
        }
      }
      .fee_list_item:last-child {
        border: none;
      }
    }
  }
}
.con {
  background: #ffffff;
  font-size: 18px !important;
  line-height: 48px !important;
  word-break: break-all !important;
  text-align: justify !important;
  color: #333333 !important;
  font-family: "arial", "PingFangSC-Regular" !important;
}
.con h1,
.con h2,
.con h3,
.con h4,
.con h5,
.con h6 {
  font-size: 18px !important;
}

.con span {
  display: inline !important;
}
.con img {
  border-radius: 8px !important;
  width: 100% !important;
}
@media screen and (max-width: 768px) {
  .file-details{
    background: #fff;
    padding: 10px 0;
  }
  .el-main {
    width: 100%;
    padding: 0 15px;
    flex-direction: column;
    .title {
      font-size: 20px;
    }
    .file-content {
      border-radius: 0;
      margin-right: 0;
      padding: 0;
    }
    .con {
      line-height: 30px !important;
    }
    .relate_article{
      width: 100%;
      box-sizing: border-box;
    }
  }
}
.file-content {
  background: #ffffff;
  border-radius: 8px;
  flex: 1;
  margin-right: 10px;
  padding: 36px 40px;
}
.relate_article {
  padding: 20px;
  width: 340px;
  background: #ffffff;
  border-radius: 8px;
  height: fit-content;
  h3 {
    font-family: MicrosoftYaHei;
    font-size: 20px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 400;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
  h3::before {
    content: "";
    width: 4px;
    height: 20px;
    background: #20317f;
    display: inline-block;
    transform: rotate(15deg);
    margin-right: 10px;
  }
  ul li {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #222222;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 400;
    cursor: pointer;
  }
}
</style>
<style>
.con table {
  width: 100% !important;
  margin-left: 0 !important;
}
.con table p,
.con table span {
  font-size: 18px !important;
  line-height: 30px !important;
  /* margin:5px!important; */
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 1;
  border-spacing: 0;
}
/* [width="4"]
{
width: 0!important;
} */

table td {
  /* word-break: break-all; 
  word-wrap:break-word; */
  border-right: 1px solid #939598;
  border-bottom: 1px solid #939598;
  /* line-height: 45px; */
}
</style>
